import React from 'react'
import PayableTab from './bankDetailsTab/PayableTab'
import Receiveable from './bankDetailsTab/Receiveable'

const BankDetails = () => {
    return (
        <div className="row-gap-2">
            <ul className="nav nav-pills mb-3 custom-tabs gap-0" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="Payable-tab" data-bs-toggle="pill" data-bs-target="#Payable" type="button" role="tab" aria-controls="Payable" aria-selected="true">Payable Details</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link" id="Receivevable-tab" data-bs-toggle="pill" data-bs-target="#Receivevable" type="button" role="tab" aria-controls="Receivevable" aria-selected="false">Receivevable Details</button>
                </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">

                <div className="tab-pane fade" id="Payable" role="tabpanel" aria-labelledby="Payable-tab">
                    <PayableTab /> {/* <BuyerReturnOrderListContent ReturnOrdersData={ReturnOrdersData} /> */}
                </div>
                <div className="tab-pane fade" id="Receivevable" role="tabpanel" aria-labelledby="Receivevable-tab">
                    <Receiveable /> {/* <BuyerReturnOrderListContent ReturnOrdersData={ReturnOrdersData} /> */}
                </div>

            </div>
        </div>
    )
}

export default BankDetails